import { List, Typography } from "@mui/material";

import { SrvProceedingListItemResponse } from "@/api";
import { useTranslation } from "@/translations";

import { SrvProceedingListItem } from "./components/srv-proceeding-list-item/SrvProceedingListItem";

interface Props {
  proceedings: SrvProceedingListItemResponse[] | undefined;
  selectedId: string | undefined;
  isFiltered: boolean;
  onSelect: (proceedingId: string) => void;
}

export function SrvProceedingList({ proceedings, selectedId, isFiltered, onSelect }: Props) {
  const { t } = useTranslation();

  if (isFiltered && proceedings?.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary" px={2}>
        {t("clients.client.debtSettlement.srvProceeding.list.noMatch")}
      </Typography>
    );
  }

  return (
    <List disablePadding sx={{ overflowY: "auto", overflowX: "hidden", flex: 1 }}>
      {proceedings?.map((proceeding) => (
        <SrvProceedingListItem
          key={proceeding.id}
          proceeding={proceeding}
          selected={proceeding.id === selectedId}
          onSelect={onSelect}
        />
      ))}
    </List>
  );
}
